import urls from './restConstants';
import api from './restApi';

export default api.custom(urls.roadmap);



// WEBPACK FOOTER //
// ./book/src/commons/rest/roadmapRest.js